export default function setType(field) {
  if (!field.type) {
    field.type = 'text'
    if (field.data && field.data.length > 0) {
      field.type = 'select'
    }
  }
  return field
}



// WEBPACK FOOTER //
// ./src/modules/app/helpers/setType.js